/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';
import ShippingIcon from 'dibs-vg/dist/react/shipping-package';
import get from 'lodash.get';

import { getShippingPrice, isPriceAboveThreshold } from './shippingHelper';

import styles from './styles.scss';

import type { Shipping_item as ItemProp } from './__generated__/Shipping_item.graphql';

type Props = {|
    currency: string,
    item: ItemProp,
|};

function ShippingBadgeComponent({ item, currency }: Props) {
    const shipmentQuote = get(item, 'lowestShipmentQuote[0]');
    const complimentaryShipping = !!get(shipmentQuote, 'complimentaryShipping');
    const convertedAmountList = get(shipmentQuote, 'totalAmount.convertedAmountList');
    const isWhiteGlove = !!get(shipmentQuote, 'serviceMethod.isWhiteGlove');
    const isFavorable = isWhiteGlove && !isPriceAboveThreshold({ convertedAmountList });

    let label = null;

    if (complimentaryShipping) {
        label = (
            <span data-tn="free-shipping">
                <FormattedMessage
                    id="dc.searchProductTile.freeShipping"
                    defaultMessage="Free Shipping"
                />
            </span>
        );
    } else if (isFavorable) {
        const price = getShippingPrice({ convertedAmountList, currency });
        label = (
            <span data-tn="favorable-white-glove">
                <FormattedMessage
                    id="dc.searchProductTile.whiteGloveShippingTitle"
                    defaultMessage="{price} White Glove Shipping"
                    values={{ price }}
                />
            </span>
        );
    }

    if (!label) {
        return null;
    }

    return (
        <div className={styles.container}>
            <ShippingIcon className={styles.icon} />
            <span className={styles.label}>{label}</span>
        </div>
    );
}

export const ShippingBadge = createFragmentContainer(ShippingBadgeComponent, {
    item: graphql`
        fragment Shipping_item on Item {
            lowestShipmentQuote {
                complimentaryShipping
                totalAmount {
                    convertedAmountList {
                        currency
                        amount
                    }
                }
                serviceMethod {
                    isWhiteGlove
                }
            }
        }
    `,
});
